import { db } from './firebase';
import { FIRESTORE_KEYS } from '../utils/constants';

export default function useConversationService() {
  const { CONVERSATION, MESSAGES } = FIRESTORE_KEYS;

  const createConversation = (data) =>
    db.collection(CONVERSATION).add({
      ...data,
    });

  const updateConversation = (docId, data) =>
    db
      .collection(CONVERSATION)
      .doc(docId)
      .update({
        ...data,
      });

  const addMessage = (conversationId, messageData) =>
    db
      .collection(CONVERSATION)
      .doc(conversationId)
      .collection(MESSAGES)
      .add({
        ...messageData,
      });

  const updateUserTokenInFirestore = async (userId, role, token) => {
    try {
      if (!userId || !role) throw new Error('Invalid user ID or role', userId, role);

      const userRef = db.collection(role).doc(userId);
      await userRef.update({ token });

      // console.log(`Updated FCM Token for ${role}:`, userId);
    } catch (error) {
      console.error('Error updating Firestore token:', error);
    }
  };

  return { createConversation, updateConversation, addMessage, updateUserTokenInFirestore };
}
